import { OrderBuyerModel } from '@steelbuy/ts-shared';

import { OrderBuyerCreateEntityData } from './OrderBuyerCreateEntityData';
import { useCreateEntityData } from '../../util/consumer/CreateEntityConsumerHook';

export const useOrderBuyerCreateEntityData = () => useCreateEntityData<OrderBuyerModel>(OrderBuyerCreateEntityData);
